module.exports = __webpack_public_path__ + "static/media/minato_default50f5ba0be8ceff05e7b836733177f35e.webp";